import { Outlet, useLocation } from 'react-router-dom'
import { useGlassLight } from '../hooks/useGlassLight'
import { usePerformanceMode } from '../hooks/usePerformanceMode'
import { ErrorBoundary } from './ui/ErrorBoundary'
import { PageFailed } from './ui/PageFailed'
import { ScrollManager } from './ui/ScrollManager'
import { Toaster } from './ui/Toaster'
import { World } from './World/World'
import { Nav } from './Nav/Nav'
import { Footer } from './Footer/Footer'

/** Shared frame for every page: the night map behind, the floating nav, the footer. */
export function Layout() {
  useGlassLight()
  usePerformanceMode()
  const { pathname } = useLocation()
  return (
    <>
      <a className="skip" href="#main">Skip to content</a>
      <ScrollManager />
      <ErrorBoundary name="background map" resetKey={pathname}><World /></ErrorBoundary>
      <ErrorBoundary name="navigation" resetKey={pathname}><Nav /></ErrorBoundary>
      <main id="main">
        <ErrorBoundary name="page" resetKey={pathname} fallback={<PageFailed />}>
          <Outlet />
        </ErrorBoundary>
      </main>
      <ErrorBoundary name="footer" resetKey={pathname}><Footer /></ErrorBoundary>
      <Toaster />
    </>
  )
}
